import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/software/VariantComparisonTable.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/app-dir/link.js");
